"use client";
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { queryFocusableElements } from '../../helpers/focus.web.js';

var TrapFocus = function TrapFocus(_ref) {
  var children = _ref.children,
    enabled = _ref.enabled,
    _ref$refProp = _ref.refProp,
    refProp = _ref$refProp === undefined ? 'ref' : _ref$refProp,
    _ref$disableFocusRest = _ref.disableFocusRestore,
    disableFocusRestore = _ref$disableFocusRest === undefined ? false : _ref$disableFocusRest;
  var containerRef = React.useRef(null);
  var restoreFocusRef = React.useRef(null);
  React.useEffect(function () {
    var containerElement = containerRef.current;
    if (!containerElement || !enabled) {
      return;
    }

    // TODO: Tab-key handling is not supported in testing-library
    // istanbul ignore next
    var tabListener = function tabListener(e) {
      if (e.key !== 'Tab') {
        return;
      }
      var childElements = queryFocusableElements(containerElement);
      if (childElements.length === 0) {
        return;
      }
      var firstElement = childElements[0];
      var lastElement = childElements[childElements.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === firstElement) {
          lastElement.focus();
          e.preventDefault();
        }
      } else if (document.activeElement === lastElement) {
        firstElement.focus();
        e.preventDefault();
      }
    };
    document.addEventListener('keydown', tabListener);
    return function () {
      document.removeEventListener('keydown', tabListener);
    };
  }, [containerRef.current, enabled]);

  // istanbul ignore next
  React.useEffect(function () {
    var containerElement = containerRef === null || containerRef === undefined ? undefined : containerRef.current;
    if (!containerElement || !enabled) {
      return;
    }
    if (document.activeElement && restoreFocusRef.current === null) {
      restoreFocusRef.current = document.activeElement;
    }
    containerElement.focus();
    return function () {
      if (restoreFocusRef.current && enabled && !disableFocusRestore) {
        restoreFocusRef.current.focus({
          preventScroll: true
        });
      }
    };
  }, [containerRef.current, enabled, disableFocusRestore]);
  return /*#__PURE__*/React.cloneElement(children, _defineProperty(_defineProperty({}, refProp, containerRef), "tabIndex", -1));
};

export { TrapFocus };
